import { render } from "./CreateLiquidation3.vue?vue&type=template&id=33200b8c"
import script from "./CreateLiquidation3.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__